import { UsersTable } from "@/components/UsersTable";

export function UsersPage() {
  return (
    <div className="mx-auto w-full max-w-[100rem] p-8">
      <h1 className="mb-6 text-2xl font-bold">Users</h1>
      <UsersTable />
    </div>
  );
}
